import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Paper from 'material-ui/Paper';
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table';
import AdminUserItem from '../item';
import AdminListToolbar from '../../common/list-toolbar/index';
import DeleteDialog from '../../common/delete-dialog/index';

const styles = theme => ({
	root: {
		margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 24}px`
	},
	createButton: {
		position: 'fixed',
		bottom: theme.spacing.unit * 6,
		right: theme.spacing.unit * 6
	}
});

const AdminUsersList = props => {
	const {
		classes,
		users,
		handlePrivilegesChange,
		handleConfirmation,
		handleDeleteItem,
		handleConfirmDelete,
		handleCancelDelete,
		deleteTarget,
		deleteConfirmation
	} = props;

	return (
		<div className={classes.root}>
			<AdminListToolbar title="Users"/>
			<Paper>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell padding="dense">
								E-Mail
							</TableCell>
							<TableCell padding="checkbox">
								Active
							</TableCell>
							<TableCell padding="checkbox">
								Privileges
							</TableCell>
							<TableCell padding="checkbox">
								Delete
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{users.map((item, index) => (
							<AdminUserItem
								key={index}
								item={item}
								onDelete={handleDeleteItem}
								onConfirmationChange={handleConfirmation}
								onPrivilegesChange={handlePrivilegesChange}
							/>
						))
						}
					</TableBody>
				</Table>
			</Paper>
			<DeleteDialog
				open={deleteConfirmation}
				deleteTarget={deleteTarget}
				handleCancel={handleCancelDelete}
				handleConfirm={handleConfirmDelete}
			/>
		</div>
	);
};

AdminUsersList.propTypes = {
	classes: PropTypes.object.isRequired,
	users: PropTypes.array.isRequired,
	deleteConfirmation: PropTypes.bool.isRequired,
	handleDeleteItem: PropTypes.func.isRequired,
	handlePrivilegesChange: PropTypes.func.isRequired,
	handleConfirmation: PropTypes.func.isRequired,
	handleConfirmDelete: PropTypes.func.isRequired,
	handleCancelDelete: PropTypes.func.isRequired,
	deleteTarget: PropTypes.object
};

export default withStyles(styles)(AdminUsersList);



// WEBPACK FOOTER //
// ./src/client/components/admin/users/list/list.jsx